import { OrderFilters, OrderSummary } from '@asset-solutions/customer-portal/orders/models';
import { createAction, props } from '@ngrx/store';

export const changeOrderFilters = createAction(
  '[Orders Page Filters Component] Filters Change',
  props<{ filters: OrderFilters }>()
);

export const resetCustomerIdsFilter = createAction('[Orders Effects] Reset CustomerIds Filter');

export const resetOrderFilters = createAction('[Orders Page Filters Component] Reset Filters');

export const liveMapChangeOrderFilters = createAction(
  '[Live Map Orders Form] Apply Filters',
  props<{ filters: OrderFilters }>()
);

export const liveMapResetOrderFilters = createAction('[Live Map Orders Form] Reset Filters');

export const getOrdersSuccess = createAction('[Orders API] Get Orders Success', props<{ orders: OrderSummary[] }>());

export const getOrdersError = createAction('[Orders API] Get Orders Error');

export const pollOrdersSuccess = createAction('[Orders API] Poll Orders Success', props<{ orders: OrderSummary[] }>());

export const clearOrders = createAction('[Customer Select Store] Clear Orders');
